<template>
  <div class="paginate" v-if="pagination.pages > 1">
    <div class="flex items-center space-x-8">
      <IconChevron class="paginate__arrow"
                   :disabled="pagination.current_page === 1"
                   @click.native="setNPage(pagination.current_page - 1)"/>
      <div class="paginate__link"
           v-if="pagination.current_page > 3"
           @click="setNPage(1)">
        1
      </div>
      <div class="paginate__spacer" v-if="pagination.current_page > 3">...</div>
      <div class="paginate__link"
           @click="setNPage(pagination.current_page-2)"
           v-show="pagination.current_page > 2">
        {{ pagination.current_page - 2 }}
      </div>
      <div class="paginate__link" @click="setNPage(pagination.current_page - 1)"
           v-show="pagination.current_page > 1">
        {{ pagination.current_page - 1 }}
      </div>
      <div class="paginate__link current">{{ pagination.current_page }}</div>
      <div class="paginate__link"
           @click="setNPage(pagination.current_page + 1)"
           v-show="pagination.current_page <= pagination.pages - 1">
        {{ pagination.current_page + 1 }}
      </div>
      <div class="paginate__link" @click="setNPage(pagination.current_page + 2)"
           v-show="pagination.current_page <= pagination.pages - 2">
        {{ pagination.current_page + 2 }}
      </div>
      <div class="paginate__spacer" v-if="pagination.current_page < pagination.pages - 3">...</div>
      <div class="paginate__link"
           v-if="pagination.current_page < pagination.pages - 2"
           @click="setNPage(pagination.pages)">
        {{ pagination.pages }}
      </div>
      <IconChevron class="paginate__arrow"
                   :disabled="pagination.current_page === pagination.pages"
                   direction="right"
                   @click.native="setNPage(pagination.current_page + 1)"/>
    </div>
  </div>
</template>

<script>
import IconChevron from "@/components/icons/IconChevron";

export default {
  name: "Pagination",
  components: {IconChevron},
  props: {
    pagination: {
      type: Object,
      required: true
    },
  },
  methods: {
    setNPage(n) {
      this.$emit('page', n);
    }
  }
}
</script>

<style scoped lang="scss">
.paginate {
  &__link {
    transition: all .2s;
    @apply text-sm text-icon-hover border-b border-icon-hover border-opacity-25 border-dashed cursor-pointer;
    &:hover {
      @apply text-red;
    }

    &.current {
      @apply text-red border-transparent;
    }
  }

  &__arrow {
    cursor: pointer;
    @apply text-icon-hover transition duration-200;
    &:hover {
      @apply text-red;
    }

    &[disabled='disabled'] {
      @apply text-icon pointer-events-none;
    }
  }

  &__spacer {
    @apply self-end text-icon-hover -mb-1;
  }
}
</style>
